import { render } from "./story_form.vue?vue&type=template&id=c8108bee&scoped=true&lang=pug"
import script from "./story_form.vue?vue&type=script&lang=js"
export * from "./story_form.vue?vue&type=script&lang=js"

import "./story_form.vue?vue&type=style&index=0&id=c8108bee&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8108bee"]])

export default __exports__